module.exports = __webpack_public_path__ + "assets/cf1d68889a1fe942c679c29b125cb258.png";